
export const config = {
    apiEndpoints: "https://ondc-ensconnect.snapdeal.com/api",
    // preprode Live
    apiEndpoint: "https://preprodphp.msmekidukan.com/public/index.php/api",
    // Preprod Local
    // apiEndpoint: "http://localhost:5001",
    nodeapiEndpoint: "https://preprod.xpressbaazaar.com/igm",
    baseNodeapiUrl: "https://preprod.xpressbaazaar.com",
    ideamasterNodeapiUrl: "https://multisellers.thesellerapp.com",
    awsKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
    awsSecretKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
    awsRegion: process.env.REACT_APP_AWS_REGION,
    awsBucket: process.env.REACT_APP_AWS_BUCKET,
    // ------------------------------- FOR MULTISELLER -----------------------------------------------
}


export function baseUrlDefiner() {
    const fullurl: any = window.location.host
    console.log("fullurlfullurl", fullurl)
    const port = window.location.port || "3000";
    console.log(fullurl)
    // const result = "http://localhost:3000";
    // const result = fullurl?.match(/\/\/(.*?)\.com/)[1];
    if(fullurl === "multipleselleradmin.thesellerapp.com"){
        return "https://multisellerpreprod.hulsecure.in//public/index.php/api"
       
    }
    if(fullurl === "preprodadmin.msmekidukan.com"){
        return  "https://ondc-ensconnect.snapdeal.com/api"
         
    }
    if (fullurl.includes(`localhost:${port}`)) {
           return "https://ondc-ensconnect.snapdeal.com/api"
        
    }
     if(fullurl === "ondc-ensdashboard.snapdeal.com"){
       return "https://ondc-ensconnect.snapdeal.com/api"
         
    }
   return "https://ondc-ensconnect.snapdeal.com/api"
}

// export function baseUrlDefiner() {
//     const fullUrl = window.location.host;
//     const port = window.location.port || "3000";
//     let apiEndpoint = "";
    
//     switch (fullUrl) {
//         case "multipleselleradmin.thesellerapp.com":
//             apiEndpoint = "https://multisellerpreprod.hulsecure.in/public/index.php/api";
            
//             break;
//         case "preprodadmin.xpressbaazaar.com":
//             apiEndpoint = "https://preprodshikharapp.hulsecure.in/public/index.php/api";
            
//             break;
//         case "wacpreprod-admin.thesellerapp.com":
//             apiEndpoint = "https://wac-preprod.hulsecure.in/public/index.php/api";
           
//             break;
//         case "multisellersadmin.thesellerapp.com":
//             apiEndpoint = "https://multisellersphp.thesellerapp.com/public/index.php/api";
//             break;
//          case "preprodadmin.msmekidukan.com":
//             apiEndpoint = "https://ondc-ensconnect-preprod.snapdeal.com/api";
//             break;
//         default:
//                 apiEndpoint = "https://ondc-ensconnect-preprod.snapdeal.com/api";
//             break;
//     }
//     return apiEndpoint;
// }
export function NodebaseUrlDefiner() {
    const fullUrl = window.location.host;
    const port = window.location.port || "3000"; 
    let baseNodeapiUrl="";
    switch (fullUrl) {
        case "multipleselleradmin.thesellerapp.com":           
            baseNodeapiUrl="https://ondc.theideamasters.com"
            break;
        case "preprodadmin.xpressbaazaar.com":         
            baseNodeapiUrl="https://preprod.xpressbaazaar.com"
            break;
        case "wacpreprod-admin.thesellerapp.com":
            baseNodeapiUrl="https://preprod.xpressbaazaar.com"
            break;
         case "preprodadmin.msmekidukan.com":
            baseNodeapiUrl="https://ondc.snapdeal.com"
            break;
        default:
                baseNodeapiUrl="https://ondc.snapdeal.com"
            
            break;
    }
    return baseNodeapiUrl;
}




